<script>
  import { priceFacet, updatePriceFacet } from './stores/facet-store.js';
  import { categoryPrice, updateMinPrice, updateMaxPrice, resetPriceFilter, categoryMinMinPrice, categoryMaxMaxPrice } from './stores/facet-price.js';
  import { afterUpdate } from 'svelte';

  $: min = $categoryPrice.minPrice;
  $: max = $categoryPrice.maxPrice;

  $: minMax = {'restrictBy[price]':`${min},${max}`};

  afterUpdate(() => {
    updatePriceFacet(minMax);
	});

  function handleMinPrice(e) {
    const { value } = e.target;

    if (isNaN(value)) {
      return;
    }

    min = Number(value);

    // Ensure user can't input numbers outside the price ranges.
    if (min > $categoryMaxMaxPrice) {
      min = $categoryMaxMaxPrice;
    }

    if (min < $categoryMinMinPrice) {
      min = $categoryMinMinPrice;
    }

    updateMinPrice(min);
  }

  function handleMaxPrice(e) {
    const { value } = e.target;

    if (isNaN(value)) {
      return;
    }

    max = Number(value);

    // Ensure user can't input numbers outside the price ranges.
    if (max > $categoryMaxMaxPrice) {
      max = $categoryMaxMaxPrice;
    }

    if (max < $categoryMinMinPrice) {
      max = $categoryMinMinPrice;
    }

    updateMaxPrice(max);
  }

  window.addEventListener('facets:clear', () => {
    min = $categoryMinMinPrice;
    max = $categoryMaxMaxPrice;

    priceFacet.set({})
    resetPriceFilter();
  });
</script>

<li class="flex items-center gap-s xl:gap-l text-b2 text-brand-blue justify-center">
  <div class="flex w-full max-w-[106px] border border-grey items-center p-[10px] space-x-[12px]">
    <span class="w-[20%]">£</span>
    <input
      type="text"
      max={$categoryMaxMaxPrice}
      min={$categoryMinMinPrice}
      class="appearance-none w-[90%] text-right focus:outline-none pl-1 "
      on:change={handleMinPrice}
      name=""
      value={min}
      aria-label="Minimum Price"
    />
  </div>

  <p class={`text-b2 font-body 'font-normal text-brand-blue'`}>
    to
  </p>

  <div class="flex w-full max-w-[106px] border border-grey items-center p-[10px] space-x-[12px]">
    <span class="w-[20%]">£</span>
    <input
      type="text"
      max={$categoryMaxMaxPrice}
      min={$categoryMinMinPrice}
      class="appearance-none w-[80%] text-right focus:outline-none pl-1"
      on:change={handleMaxPrice}
      name=""
      value={max}
      aria-label="Maximum Price"
    />
  </div>
</li>